import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
import { LogoComponent } from '../../atoms/logo';
import { NavbarComponent } from '../../atoms/navbar';
import { InputComponent } from '../../atoms/input';
import {
  BBArrowDownFilledIcon,
  BbCloseIcon,
  BBSearchIcon,
} from '../../quarks/icons';
import { HeaderStyle } from './style';
import { useHistory, useParams } from 'react-router-dom';

export const HeaderComponent = (props) => {

  const history = useHistory();
  const params = useParams();

  const [focusInputOnRender, setFocusInputOnRender] = useState(
    history.location.pathname === '/app/search' && !params?.search
      ? true
      : false
  );

  const [isOpen, setIsOpen] = useState(props.isOpen);

  const handleClick = () => {
    const newIsOpen = !isOpen;
    setIsOpen(newIsOpen);
    props.onLogoClick({ isOpen: newIsOpen });
  };

  return (
    <HeaderStyle {...props}>
      <NavbarComponent>
        <div className="navbar_area">
          <div className="logo_area" onClick={handleClick}>
            <LogoComponent />
            <BBArrowDownFilledIcon
              isUpDirection={isOpen}
              width={10}
              height={8}
            />
          </div>
          <div className="search_area">
            <InputComponent
              id="inputHeader"
              placeholder="Digite aqui e procure em todo o conteúdo"
              icon={
                props.inputValue.length > 0 ? (
                  <button
                    className="search_input_clear_icon"
                    onClick={props.onClearInput}
                  >
                    <BbCloseIcon />
                  </button>
                ) : (
                  <BBSearchIcon />
                )
              }
              value={props.inputValue}
              onChange={props.onChange}
              onFocus={props.onInputFocus}
              onBlur={props?.onInputBlur}
              autoFocus={focusInputOnRender}
              onKeyDown={props?.handlePressKey}
            />
          </div>
        </div>
      </NavbarComponent>
    </HeaderStyle>
  );
};

HeaderComponent.propTypes = {
  avatar: PropTypes.string,
  userName: PropTypes.string,
  onChange: PropTypes.func,
  onLogoClick: PropTypes.func,
  onInputFocus: PropTypes.func,
  isOpen: PropTypes.bool,
};
